module.exports = __webpack_public_path__ + "static/img/overseasMarket.b362df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/overseasMarket/overseasMarket.png
// module id = cdV1
// module chunks = 13